const schemas = {
  EveryMatrix: (data) => ({
    // Credentials
    email: data.credentials.email,
    username: data.credentials.username,
    alias: data.credentials.alias,
    password: data.credentials.password,
    confirm: data.credentials.password,
    passwordRepeat: data.credentials.password,
    // User data
    birthDate: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    dob: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    gender: data.user.gender && data.user.gender.slice(0, 1).toUpperCase(),
    postalCode: data.user.postalCode,
    country: data.user.country,
    region: data.user.province,
    city: data.user.city,
    address1: data.user.houseNumber + ' ' + data.user.streetName,
    phone: data.user.phone,
    mobile: data.user.mobile,
    currency: data.user.currency,
    // GDPR
    acceptNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
    acceptSMSOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
  }),

  GIG: (data) => {
    const birthdate = data.user.birthdate
    return {
      // Credentials
      email: data.credentials.email,
      username: data.credentials.username,
      password: data.credentials.password,
      repeatPassword: data.credentials.password,
      // User data
      birth: birthdate && birthdate.toISOString().split('T')[0],
      ddlDay: birthdate && birthdate.getDate(),
      ddlMonth: birthdate && birthdate.getMonth() + 1,
      ddlYear: birthdate && birthdate.getFullYear(),
      title: data.user.title,
      firstname: data.user.firstName,
      surname: data.user.lastName,
      currency: data.user.currency,
      securityQuestion: data.user.securityQuestion,
      securityAnswer: data.user.securityAnswer,
      postalCode: data.user.postalCode,
      country: data.user.country,
      city: data.user.city,
      address1: data.user.houseNumber + ' ' + data.user.streetName,
      phone: data.user.phoneWithoutPrefix,
      phonePrefix: data.user.phonePrefix,
      mobile: data.user.phoneWithoutPrefix,
      mobilePrefix: data.user.phonePrefix,
      // GDPR
      consent_termsandconditions: data.consent.terms ? 'yes' : 'no',
      consent_emailmarketing: data.consent.offer_email ? 'yes' : 'no',
      consent_sms: data.consent.offer_sms ? 'yes' : 'no',
      consent_3rdparty: data.consent.thirdparty ? 'yes' : 'no',
      acceptTermsConditions: (data.consent.terms && data.consent.terms.consent) || false,
      allowNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
      allowSmsOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
    }
  },
  nyspins: (data) => {
    const birthdate = data.user.birthdate
    let year, month, day
    if (birthdate) {
      year = birthdate && birthdate.getFullYear()
      month = birthdate && birthdate.getMonth() + 1
      if (month < 10) month = '0' + month.toString()
      day = birthdate && birthdate.getDate()
      if (day < 10) day = '0' + day.toString()
    }

    return {
      // Credentials
      email: data.credentials.email,
      password: data.credentials.password,
      // User data
      'birth-date': birthdate && year && month && day ? `${year}-${month}-${day}` : '',
      'first-name': data.user.firstName,
      'last-name': data.user.lastName,
      'currency-to': data.user.currency,
      'postal-code': data.user.postalCode,
      'country-to': data.user.country,
      city: data.user.city,
      address1: data.user.houseNumber + ' ' + data.user.streetName,
      nationality: data.user.nationality,
      mobile: data.user.phoneWithoutPrefix,
      'mobile-prefix': data.user.phonePrefix,
      'sex-to': data.user.gender && data.user.gender.slice(0, 1).toUpperCase() === 'M' ? 1
        : data.user.gender && data.user.gender.slice(0, 1).toUpperCase() === 'F' ? 2
          : undefined,
      // GDPR
      'accept-terms': (data.consent.terms && data.consent.terms.consent) || false,
      'does-not-allow-news-and-offers-email': !((data.consent.offers && data.consent.offers.consent) || (data.consent.offers_email && data.consent.offers_email.consent) || false),
      'does-not-allow-news-and-offers-sms': !((data.consent.offers && data.consent.offers.consent) || (data.consent.offers_sms && data.consent.offers_sms.consent) || false),
      'does-not-allow-news-and-offers-phone': !((data.consent.offers && data.consent.offers.consent) || (data.consent.offers_phone && data.consent.offers_phone.consent) || false),
      'does-not-allow-news-and-offers-mail': !((data.consent.offers && data.consent.offers.consent) || (data.consent.offers_mail && data.consent.offers_mail.consent) || false)
    }
  }
}

/*
mapped: {
  "accountCountry": "DE"
  "addressDeliverable": null
  "bankCode": "00000"
  "birthdate": "01/16/1953"
  "birthplace": {city: "Berlin", country: "DE"}
  "city": "Wolfsburg"
  "country": "DE"
  "depositLimit": "950"
  "existing": false
  "firstName": "Hans-Gerd"
  "fullName": "Hans-Gerd Warnecke"
  "gender": "male"
  "hasMaidenName": false
  "houseNumber": "10"
  "language": "en"
  "lastName": "Warnecke"
  "maidenName": "Warnecke"
  "nationality": "DE"
  "phone": "01701234567"
  "phoneCountry": "DE"
  "phoneE164": "+491701234567"
  "phonePrefix": "+49"
  "phoneWithoutPrefix": "1701234567"
  "postalCode": "38444"
  "streetName": "Altenburger Str."
}
*/

const transformData = (data, schema) => schemas[schema](data)

export default transformData



// WEBPACK FOOTER //
// ./src/utils/data-transfrom.js